import { L2vpnSubscriptionDetails } from "../../pages/subscription-detail/types";
import { ESI } from "./models/types";

export class ModifyL2VPN {
  // @ts-expect-error: There is a null/undefined/typing issue; please fix me!
  protected esis: ESI[];
  protected speed_policer?: boolean;

  set speedPolicer(val: boolean) {
    this.speed_policer = val;
  }

  set subscription(sub: L2vpnSubscriptionDetails) {
    this.esis = sub.esis
      .map((esi) =>
        (esi.endpoints ?? []).flatMap((endpoint) =>
          endpoint.port ? [{ subscription_id: endpoint.port.subscriptionId, vlan: endpoint.vlanrange }] : [],
        ),
      )
      .filter((ports) => ports.length > 0);

    this.speed_policer = sub.speedPolicer;
  }

  setEsis(esis: ESI[]) {
    this.esis = esis;
  }
}

export class ModifyL2VPNSpeedPolicer extends ModifyL2VPN {
  get payload() {
    return {
      speed_policer: this.speed_policer,
    };
  }
}

export class ModifyL2VPNVlan extends ModifyL2VPN {
  get payload() {
    return {
      esis: this.esis,
    };
  }
}

export class ModifyL2VPNRemovePort extends ModifyL2VPN {
  get payload() {
    return {
      esis: this.esis.map((esi) =>
        esi.map((port) => ({
          subscription_id: port.subscription_id,
          vlan: port.vlan,
        })),
      ),
    };
  }
}

export class ModifyL2VPNAddPort extends ModifyL2VPN {
  get payload() {
    return {
      esis: this.esis,
    };
  }
}
